// Public healthcare case-study material already shown on the homepage.
// This was a separate, previous custom engagement, not a promise of AI 90 scope
// or a new claim of measured financial performance.
export const HEALTHCARE_PLAYBOOK_CONTENTS = [
  "AI usage policies and governance",
  "Department-specific prompt libraries",
  "Tool selection and integration guides",
  "Quality and validation checklists",
  "ROI tracking and success metrics",
  "Security and compliance guidelines",
];

export const HEALTHCARE_TEAM_PROGRESS = [
  {
    before: "Different understandings of AI",
    after: "A shared language, from executives to analysts",
  },
  {
    before: "Unclear connections to daily work",
    after: "Department workflows tied to practical applications",
  },
  {
    before: "No common framework for adoption",
    after: "A company playbook and ongoing implementation support",
  },
];

// Exact public testimonial.to excerpts already shown on the homepage.
// Provenance: docs/plans/2026-10-19-homepage-company-overview.md.
// Feedback is from across our programs, not specifically AI 90. These quotes
// describe participant experiences, not independently verified performance.
export const TEAM_PROGRAM_TESTIMONIALS = [
  {
    name: "Marco Monteiro",
    role: "Program participant",
    quote:
      "With the help of this program, I can focus on building better solutions and significantly reduce the time I spend on repetitive tasks.",
  },
  {
    name: "Pamela Johnston",
    role: "Senior Business Strategy Consultant · Program participant",
    quote:
      "Tech Leaders will meet you where you are with patience, understanding, and real practical help.",
  },
];
